import { OptionCDT } from '../../Utils/selectOptions';
import { client } from '../client';

export const listCDTOptions = async (): Promise<OptionCDT[]> => {
  const { data } = await client.get('/cdts');

  return data;
};
